import {
  QUESTION_CHANGE_STATES,
  QUESTION_KEYS,
  QUESTION_OPTION_KEYS,
  QUESTION_TYPES,
} from "schedule-v2/components/recorded-content/recordedContent.data";
import { is_empty } from "utils/validations";
import { EXAM_PAGES, FORM_PAGES } from "./questionsModal.data";

export const finalFormArraysErrorKey = "FINAL_FORM/array-error";

export const validators = {
  form: ({ values, page, isExam }) => {
    const PAGES = isExam ? EXAM_PAGES : FORM_PAGES;

    const {
      [QUESTION_KEYS.questionType]: questionType,
      [QUESTION_KEYS.options]: options,
    } = values;

    if (is_empty(questionType))
      return {
        [QUESTION_KEYS.questionType]: "Please select question type.",
      };

    const isSingleOrMultiSelect =
      questionType === QUESTION_TYPES.SINGLE_SELECT ||
      questionType === QUESTION_TYPES.MULTI_SELECT;

    if (
      page === PAGES.ADD_DETAILS &&
      isSingleOrMultiSelect &&
      is_empty(getAddedOptions(options))
    )
      return { [QUESTION_KEYS.options]: "Please add options." };
  },
};

export const formatErrorMessage = (errors) =>
  Object.entries(errors).map(([key, error]) => {
    if (key === QUESTION_KEYS.options)
      return typeof error === "string" // if it's a single error
        ? error
        : error?.[finalFormArraysErrorKey] ||
            "Please enter option in all fields."; // if it's an array of errors
    if (key === QUESTION_KEYS.metadata) return Object.values(error).pop();
    return error;
  });

export const getAddedOptions = (options) =>
  options?.filter(
    (option) =>
      option?.[QUESTION_OPTION_KEYS.changeType] !==
      QUESTION_CHANGE_STATES.DELETED
  );
